import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Button, Typography } from '@material-ui/core';
import FormCheckBoxWithLabel from '../legacyForm/FormCheckBoxWithLabel';

const ParticipantSettingsForm = ({ t, onSubmit, initialValues }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Typography variant="overline" gutterBottom>
            Powiadomienie email
          </Typography>
          <div>
            <Field
              name="notificationSettings.consultationActivatedNotificationEnabled"
              component={FormCheckBoxWithLabel}
              label="Udostępnienie nowej konsultacji"
              type="checkbox"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="notificationSettings.consultationClosedNotificationEnabled"
              component={FormCheckBoxWithLabel}
              label="Udostępnienie wyników konsultacji"
              type="checkbox"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="notificationSettings.upcomingConsultationNotificationEnabled"
              component={FormCheckBoxWithLabel}
              label="Zbliżające się konsultacje"
              type="checkbox"
              fullWidth
            />
          </div>
          
          <Button variant="contained" color="primary" type="submit" disabled={submitting} style={{ marginTop: 20 }}>
            {submitting ? t('auth.userProfile.submitInProgressButton') : t('auth.userProfile.submitButton')}
          </Button>
        </form>
      )}
    />
  );
};

ParticipantSettingsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default translate()(ParticipantSettingsForm);



// WEBPACK FOOTER //
// ./src/components/userProfile/ParticipantSettingsForm.js